import TagAutocomplete from "./TagAutocomplete";

export default TagAutocomplete;
